module.exports = __webpack_public_path__ + "img/tb.fc2e1d32.png";